
try {
  process.dlopen(module, __dirname + require("path").sep + __webpack_public_path__ + "2b84c982c93850d7586ac93402d727cb.node");
} catch (error) {
  throw new Error('node-loader:\n' + error);
}
